import { useMemo } from "react";

type TRGB = {
  r: number;
  g: number;
  b: number;
};

// 计算相对亮度 (WCAG 2.0)
function getRelativeLuminance(rgb: TRGB) {
  let r = rgb.r / 255;
  let g = rgb.g / 255;
  let b = rgb.b / 255;

  // 伽马校正
  r = r <= 0.03928 ? r / 12.92 : Math.pow((r + 0.055) / 1.055, 2.4);
  g = g <= 0.03928 ? g / 12.92 : Math.pow((g + 0.055) / 1.055, 2.4);
  b = b <= 0.03928 ? b / 12.92 : Math.pow((b + 0.055) / 1.055, 2.4);

  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// 计算对比度 (WCAG 2.0)
function calculateContrast(color1: TRGB, color2: TRGB) {
  const lum1 = getRelativeLuminance(color1);
  const lum2 = getRelativeLuminance(color2);

  const lighter = Math.max(lum1, lum2);
  const darker = Math.min(lum1, lum2);

  return (lighter + 0.05) / (darker + 0.05);
}

// 计算色调值（0-360）
function rgbToHue(rgb: TRGB) {
  const r = rgb.r / 255;
  const g = rgb.g / 255;
  const b = rgb.b / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let hue = 0;

  if (max === min) {
    hue = 0;
  } else if (max === r) {
    hue = ((g - b) / (max - min)) * 60;
  } else if (max === g) {
    hue = ((b - r) / (max - min) + 2) * 60;
  } else {
    hue = ((r - g) / (max - min) + 4) * 60;
  }

  if (hue < 0) hue += 360;
  return hue;
}

// 辅助函数：16进制转RGB
function hexToRgb(hex: string) {
  hex = hex.replace(/^#/, "");
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return { r, g, b };
}

const TransparentImgBgClass = {
  dark: "transparent-img-black-bg",
  light: "transparent-img-bg",
};

export function getPngBgClass(color: string) {
  if (!color) return TransparentImgBgClass.light;

  const rgb = hexToRgb(color);

  // 计算对比度（相对于白色）
  const contrast = calculateContrast(rgb, { r: 255, g: 255, b: 255 });

  // 根据对比度决定推荐的背景色
  // 对比度阈值设定为 2（低于此值使用深色背景）
  const useDarkBackground = contrast < 1.3;
  return TransparentImgBgClass[useDarkBackground ? "dark" : "light"];
}

// 根据图片主色，返回明暗的透明背景
export default function usePngBg(color: string) {
  return useMemo(() => {
    return getPngBgClass(color);
  }, [color]);

  // const [bgClass, setBgClass] = useState(defaultClass);

  // const onImageLoad = useMemoizedFn((evt) => {
  //   // 异步更新背景
  //   const bestBg = decideBestBackground(evt.target);
  //   setBgClass(TransparentImgBgClass[bestBg]);
  // });

  // return [bgClass];
}
